import { render, staticRenderFns } from "./team-day.vue?vue&type=template&id=c9165986&scoped=true"
import script from "./team-day.vue?vue&type=script&lang=ts"
export * from "./team-day.vue?vue&type=script&lang=ts"
import style0 from "./team-day.vue?vue&type=style&index=0&id=c9165986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9165986",
  null
  
)

export default component.exports